(function () {
  document.querySelectorAll('.txp:not([data-ready])').forEach(function (s) {
    s.dataset.ready = '1';
    var sid = s.dataset.section, d2 = s.dataset.d2, d3 = s.dataset.d3;
    var form = s.querySelector('form.txp__form'), qty = s.querySelector('[data-txp-qty]');
    var label = s.querySelector('[data-txp-atc-label]'), btn = s.querySelector('[data-txp-atc]'), err = s.querySelector('[data-txp-err]');
    var now = s.querySelector('[data-txp-now]'), was = s.querySelector('[data-txp-was]'), st = s.querySelector('[data-txp-savetxt]');
    var sn = s.querySelector('[data-txp-sticky-name]'), sp = s.querySelector('[data-txp-sticky-price]');
    var names = { '1': '1 set', '2': '2 sets · Save ' + d2 + '%', '3': '3 sets · Save ' + d3 + '%' };
    var radios = s.querySelectorAll('input[name="txp-tier-' + sid + '"]');
    function sync() {
      var r = s.querySelector('input[name="txp-tier-' + sid + '"]:checked'); if (!r) return;
      qty.value = r.value;
      if (label) label.textContent = 'Add to cart · ' + r.dataset.now;
      if (now) now.textContent = r.dataset.now;
      if (was) { was.textContent = r.dataset.was; was.hidden = !r.dataset.showwas; }
      var save = +r.dataset.save;
      if (st) { st.hidden = save <= 0; if (save > 0 && window.TRVX) st.textContent = 'You save ' + window.TRVX.money(save); }
      if (sn) sn.textContent = names[r.value];
      if (sp) sp.textContent = r.dataset.now;
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
    if (form) form.addEventListener('submit', function (e) {
      if (!window.TRVX) return;
      e.preventDefault(); err.hidden = true; btn.disabled = true;
      var old = label ? label.textContent : ''; if (label) label.textContent = 'Adding…';
      window.TRVX.add(form.querySelector('[name="id"]').value, qty.value)
        .catch(function (x) { err.textContent = (x && (x.description || x.message)) || 'Something went wrong. Please try again.'; err.hidden = false; })
        .finally(function () { btn.disabled = false; if (label) label.textContent = old; });
    });
    var slider = s.querySelector('[data-txp-slider]'), thumbs = s.querySelectorAll('[data-txp-thumb]');
    thumbs.forEach(function (t) { t.addEventListener('click', function () { slider.scrollTo({ left: slider.clientWidth * +t.dataset.txpThumb, behavior: 'smooth' }); }); });
    if (slider && thumbs.length) {
      var tick;
      slider.addEventListener('scroll', function () {
        cancelAnimationFrame(tick);
        tick = requestAnimationFrame(function () {
          var i = Math.round(slider.scrollLeft / slider.clientWidth);
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
          var a = thumbs[i]; if (a && a.parentNode) a.parentNode.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' });
        });
      }, { passive: true });
    }
    var sticky = s.querySelector('[data-txp-sticky]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(btn);
      s.querySelector('[data-txp-sticky-btn]').addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  });
})();